import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { WalletConnectWalletAdapter } from "@walletconnect/solana-adapter";
import * as Wallets from "@solana/wallet-adapter-wallets";

export const supportedWallets = [
    "Phantom",
    "Coinbase Wallet",
    "Backpack",
    "Solflare",
    "Glow",
    "Magic Eden",
    "SquadsX",
    "NuFi",
    "WalletConnect",
    "Brave Wallet",
    "OKX Wallet"
];

export const walletAdapters = [
    new WalletConnectWalletAdapter({
        network: WalletAdapterNetwork.Mainnet,
        options: {
            projectId: "47b3724db04568f96c09305aeb3a020e",
            relayUrl: "wss://relay.walletconnect.com",
            metadata: {
                name: "Loopscale",
                description: "Next generation borrow/lend on Solana",
                url: "https://app.loopscale.com",
                icons: ["https://bridgesplit-app.s3.us-east-1.amazonaws.com/logo/logo_new_blue.png"]
            }
        }
    }),
    new Wallets.AlphaWalletAdapter(),
    new Wallets.AvanaWalletAdapter(),
    new Wallets.BitpieWalletAdapter(),
    new Wallets.CloverWalletAdapter(),
    new Wallets.Coin98WalletAdapter(),
    new Wallets.CoinbaseWalletAdapter(),
    new Wallets.CoinhubWalletAdapter(),
    new Wallets.FractalWalletAdapter(),
    new Wallets.HuobiWalletAdapter(),
    new Wallets.HyperPayWalletAdapter(),
    new Wallets.KeystoneWalletAdapter(),
    new Wallets.KrystalWalletAdapter(),
    new Wallets.LedgerWalletAdapter(),
    new Wallets.MathWalletAdapter(),
    new Wallets.NekoWalletAdapter(),
    new Wallets.NightlyWalletAdapter(),
    new Wallets.NufiWalletAdapter(),
    new Wallets.OntoWalletAdapter(),
    new Wallets.SafePalWalletAdapter(),
    new Wallets.SaifuWalletAdapter(),
    new Wallets.SalmonWalletAdapter(),
    new Wallets.SkyWalletAdapter(),
    new Wallets.SolongWalletAdapter(),
    new Wallets.SpotWalletAdapter(),
    new Wallets.TokenaryWalletAdapter(),
    new Wallets.TokenPocketWalletAdapter(),
    new Wallets.TorusWalletAdapter(),
    new Wallets.TrezorWalletAdapter(),
    new Wallets.TrustWalletAdapter(),
    new Wallets.XDEFIWalletAdapter()
];
